module.exports = __webpack_public_path__ + "img/about_004.d8df9c7.png";